import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Modal from '@/components/ModalV2';

interface FormModalProps {
  onClose?: () => void;
  testId?: string;
}

const FormModal: FunctionComponent<FormModalProps> = ({
  onClose,
  testId,
  children,
}) => (
  <Modal
    open
    sx={{
      width: '860px',
      maxHeight: 'calc(100% - 196px)',
      padding: '24px',
      borderRadius: '8px',
      overflow: 'auto',
    }}
    data-testid={testId}
  >
    <Flex sx={{ flexDirection: 'column', gap: 'xl', width: '100%' }}>
      <Box
        sx={{
          width: '100%',
          color: 't.black80',
          fontWeight: 400,
          fontSize: '22px',
          lineHeight: 'normal',
          textAlign: 'end',
        }}
      >
        <FontAwesomeIcon
          style={{ cursor: 'pointer' }}
          icon={faXmark}
          onClick={onClose}
        />
      </Box>
      {children}
    </Flex>
  </Modal>
);

export default FormModal;
